import { render, staticRenderFns } from "./ViewActivityPage.vue?vue&type=template&id=6b04ef09&scoped=true&"
import script from "./ViewActivityPage.vue?vue&type=script&lang=js&"
export * from "./ViewActivityPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewActivityPage.vue?vue&type=style&index=0&id=6b04ef09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b04ef09",
  null
  
)

export default component.exports